module.exports = __webpack_public_path__ + "img/logo-roma.75da7e67.svg";